// extracted by mini-css-extract-plugin
var _1 = "FieldArray_addButton__1add1";
var _2 = "FieldArray_bordered__fdc0a";
var _3 = "FieldArray_padding__5fd8d";
var _4 = "FieldArray_root__16913";
export { _1 as "addButton", _2 as "bordered", _3 as "padding", _4 as "root" }
